<template>
  <!-- <simple-select :commonOptions="commonOptions"
                                 @getSelectValue="getSanctionValue"
                                 :value="addSeniorManage.sanction"
                                 label="Sanction"
                                 valueKey="sanction"
                                 ref="sactionSelectCom"></simple-select> -->
  <div class="form-group with-icon-right"
       :class="{'has-error': initVaildSelect, 'valid': isVaild(valueKey)}">
    <div class="input-group">
      <vuestic-simple-select :name="valueKey"
                             :data-vv-as="label"
                             v-validate="'required'"
                             required
                             :label="label"
                             v-model="selectValue"
                             :options="commonOptions"
                             ref="myInput"
                             @input="forbiddenInput" />
      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
      <i class="fa icon-right input-icon"></i>
      <small v-show="initVaildSelect"
             class="help text-danger">{{ errors.first(valueKey) }}</small>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    valueKey: {
      type: String,
    },
    commonOptions: {
      type: Array,
      default: () => [],
    },
    // errors: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  data() {
    return {
      status: false,
      selectValue: "",
    };
  },
  mounted() {
    this.selectValue = this.value;
  },
  computed: {
    initVaildSelect() {
      return this.status;
    },
  },
  methods: {
    isVaild(field) {
      let isValid = false;
      if (this.status) {
        isValid = true;
      }
      return isValid;
    },
    forbiddenInput(val) {
      this.$emit("getSelectValue", val);
      if (!val) {
        this.$refs.myInput.$el.getElementsByTagName("input")[0].style.height =
          "28px";
        this.status = true;
      } else {
        this.status = false;
      }
    },
  },
};
</script>
<style scoped>
</style>